var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-error',{attrs:{"no-appbar":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Erreur interne")]},proxy:true}])},[_c('h1',[_vm._v("Erreur interne")]),_c('p',[_vm._v("Désolé, une erreur interne est survenue.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }